// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__z-sQT","overlay":"loader_overlay__6WVlN","ldsRing":"loader_ldsRing__4okxN","bg":"loader_bg__21NnR"};